import { get } from 'lodash-es';

import { emptyArray } from 'ui-components/default-props/empty';

export const selectAppliedFiltersByViewId = (state, props) => {
  return get(state, `${props.statusViewId}.appliedFilters`, emptyArray);
};
